module.exports = __webpack_public_path__ + "img/1489430092.7261da2a.jpg";